import { ChangeDetectorRef } from '@angular/core';
import { blockInitialAnimation, fullscreenAnimation } from './animations';
import { RouterLoadingIndicatorComponent } from '@core/frontend-shared/router/loading-indicator.component';
import { CustomRouterOutlet } from '@core/frontend-shared/router/router-outlet/custom-router-outlet';
import * as i0 from "@angular/core";
function LayoutRouterOutletFullscreenComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "custom-router-outlet", 3, 0);
  }
}
/**
 * router-outlet-fullscreen will make the routed component ALWAYS display filling the available space.
 * Layouting and scrolling must be managed within the component! (component overflow will be set to auto)
 */
export let LayoutRouterOutletFullscreenComponent = /*#__PURE__*/(() => {
  class LayoutRouterOutletFullscreenComponent {
    constructor(cdRef) {
      this.cdRef = cdRef;
      this.animate = false;
    }
    ngAfterViewInit() {
      // Skip initial animation as Safari is having trouble to render correctly
      setTimeout(() => {
        this.animate = true;
        this.cdRef.markForCheck();
      }, 50);
    }
    animationState(outlet) {
      if (!this.animate) return null;
      return outlet.isActivated ? outlet.activatedRoute : '';
    }
    static {
      this.ɵfac = function LayoutRouterOutletFullscreenComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || LayoutRouterOutletFullscreenComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: LayoutRouterOutletFullscreenComponent,
        selectors: [["router-outlet-fullscreen"]],
        decls: 6,
        vars: 2,
        consts: [["o", "outlet"], ["defaultContent", ""], [1, "layout-content"], [1, "layout-router-outlet"]],
        template: function LayoutRouterOutletFullscreenComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelement(0, "router-loading-indicator");
            i0.ɵɵelementStart(1, "div", 2);
            i0.ɵɵelement(2, "custom-router-outlet", 3, 0);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(4, LayoutRouterOutletFullscreenComponent_ng_template_4_Template, 2, 0, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            const o_r1 = i0.ɵɵreference(3);
            i0.ɵɵadvance();
            i0.ɵɵproperty("@fullscreenAnimation", ctx.animationState(o_r1))("@.disabled", !ctx.animate);
          }
        },
        dependencies: [RouterLoadingIndicatorComponent, CustomRouterOutlet],
        styles: ["[_nghost-%COMP%]{overflow:visible!important;overflow-y:auto;width:100%;min-height:100%;max-width:100%;inset:0;padding:0!important;position:absolute;display:flex;flex-direction:column}  .layout-router-outlet~*{position:absolute;inset:0;display:block;overflow:auto}.layout-content[_ngcontent-%COMP%]{flex:1}div[_ngcontent-%COMP%]{min-height:100%;flex:1 1 auto}"],
        data: {
          animation: [fullscreenAnimation, blockInitialAnimation]
        }
      });
    }
  }
  return LayoutRouterOutletFullscreenComponent;
})();